import { color } from '@nuvolo/nuux-theme/utils';
import type { CustomChipColors } from '#/common/utils/wrappers/withChip';
import { dataSources } from '../../tenants/utils/mappings';

export const syncStatus = {
  pending: { key: 'pending', label: 'Pending' },
  ['in-progress']: { key: 'in-progress', label: 'In Progress' },
  successful: { key: 'successful', label: 'Successful' },
  partial: { key: 'partial', label: 'Partial' },
  error: { key: 'error', label: 'Error' },
} as const;

export type SyncStatus = keyof typeof syncStatus;

export const syncStatusList = Object.values(syncStatus);

export const syncType = {
  Account: { key: 'Account', label: 'Account (all)' },
  AssetsAndLocations: { key: 'AssetsAndLocations', label: 'Assets and Locations' },
  Users: { key: 'Users', label: 'Users' },
  Exceptions: { key: 'Exceptions', label: 'Exceptions' },
  Findings: { key: 'Findings', label: 'Findings' },
} as const;

export const syncTypeList = Object.values(syncType);

export const syncHistoryStatusColors: Record<SyncStatus, CustomChipColors> = {
  'in-progress': {
    backgroundColor: color('info', 'dark', 0.15),
    textColor: color('info', 'dark'),
  },
  successful: {
    backgroundColor: color('success', 'dark', 0.15),
    textColor: color('success', 'dark'),
  },
  partial: {
    backgroundColor: color('reporting', 'green', 0.15),
    textColor: color('reporting', 'green'),
  },
  pending: {
    backgroundColor: color('reporting', 'green', 0.15),
    textColor: color('reporting', 'green'),
  },
  error: {
    backgroundColor: color('error', 'dark', 0.15),
    textColor: color('error', 'dark'),
  },
};

export const syncHistoryTypeRoutes: Record<string, string> = {
  AssetsAndLocations: '/assets',
  Users: '/admin/users',
  Exceptions: '/alerts',
  Findings: '/findings',
  Models: '/assets/models',
  Manufacturers: '/assets/manufacturers',
};

export const syncSources = {
  tis: dataSources.tis,
  fsm: dataSources.fsm,
} as const;

export const syncSourceList = Object.values(syncSources);
